import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

/** Which account attribute the copy action puts on the clipboard. */
export type AccountCopyField = 'name' | 'label';

/** Persisted user interface preferences. */
export interface PreferencesState {
  accountCopyField: AccountCopyField;
}

export const initialState: PreferencesState = {
  accountCopyField: 'label',
};

/**
 * The slice name doubles as the redux-persist namespace in the dashboard, so
 * renaming it silently drops every saved preference.
 */
export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setAccountCopyField(state, action: PayloadAction<{ value: AccountCopyField }>) {
      state.accountCopyField = action.payload.value;
    },
    resetPreferences: () => initialState,
  },
});

export const preferencesActions = preferencesSlice.actions;

export default preferencesSlice.reducer;
